export const ANIMATION_DURATIONS = {
  FAST: 150,
  NORMAL: 200,
  SLOW: 300,
  VERY_SLOW: 750,
} as const;

export const TRANSITION_SCALES = {
  ZOOM_IN: 1.1,
  ZOOM_OUT: 0.9,
  PRESS: 0.95,
  HOVER: 1.05,
} as const;

export const ANIMATION_TIMING = {
  EASE_IN: 'ease-in',
  EASE_OUT: 'ease-out',
  EASE_IN_OUT: 'ease-in-out',
  LINEAR: 'linear',
} as const;
